import { EstimationInput } from '../App';
import { calculateCafe } from '../calculation/calculations/cafe';
import {
  Countries,
  getEmissionsByCountryRegion,
  parseCountry,
  parseCountryRegion,
} from '../calculation/calculations';
import { calculateConsultant } from '../calculation/calculations/consultant';
import { calculateHairdresser } from '../calculation/calculations/hairdressers';
import { calculateHomeOffice } from '../calculation/calculations/homeOffice';
import { calculateIT } from '../calculation/calculations/it';
import { calculateMotels } from '../calculation/calculations/motels';
import { calculateRestaurant } from '../calculation/calculations/restaurant';
import { calculateRetail } from '../calculation/calculations/retail';
import { calculateYachtingBoating } from '../calculation/calculations/yachtingboating';
import { IndustryIdType } from './merchantConfigs';
import { GeneralRegion } from './countries';
import { calculateEmissionOffice } from '../calculation/calculations/office';
import { calculateEcommerce } from '../calculation/calculations/e-commerce';

export type EmissionCalculationInTonnes = number;

const needsRoomInput: IndustryIdType[] = ['Motels'];

export const usesNeedsRoomInput = (industry: IndustryIdType) => {
  return needsRoomInput.includes(industry);
};

export const getEmissionCalculation = (
  input: EstimationInput,
  countryCode: Countries,
  regionKey: GeneralRegion,
): EmissionCalculationInTonnes => {
  const country = parseCountry(countryCode);
  const region = parseCountryRegion(country, regionKey);
  const emissions = getEmissionsByCountryRegion(country, region);

  switch (input.industryId) {
    case 'E-Commerce':
      return calculateEcommerce(emissions, input);

    case 'Home office':
      return calculateHomeOffice(emissions, input);

    case 'Health clinics':
    case 'Accountant':
    case 'Professional services':
    case 'Architect':
    case 'Lawyers':
      return calculateEmissionOffice(emissions, input);

    case 'Motels':
      return calculateMotels(emissions, input);

    case 'Café':
      return calculateCafe(emissions, input);

    case 'IT services':
      return calculateIT(emissions, input);

    case 'Surveyor':
    case 'Real estate agent':
    case 'Consultants':
      return calculateConsultant(emissions, input);

    case 'Hairdresser':
      return calculateHairdresser(emissions, input);
    case 'Restaurants':
      return calculateRestaurant(emissions, input);
    case 'Retail':
      return calculateRetail(emissions, input);

    case 'Yachting / Boating':
      return calculateYachtingBoating(input);
      break;
  }
  console.error(input);
  throw new Error(
    `${input.industryId} calculation not found. See console for more details`,
  );
};
